import { Link } from "react-router-dom";
import config from "config.json";

function App({ team, id }) {
  // get the teams in the backend;
  return (
    <Link className="box teamCard" to={`/equipas/${id}`}>
        <p className="label">{team.name}</p>
        {/* -1 because we don't count with the club profile */}
        <p className="label">{team?.accounts?.data ? team.accounts.data.length - 1: 0} Membro(s)</p> 
        <p className="label">{team.level}</p>
        <p className="label">{team.division && team.division != '' ? config.DIVISIONS_OPTIONS.find((el) => el.value === team.division).label : ''}</p>
        <p className="label">{team.manager}</p>
    </Link>
  );
}

export default App;
